import axios from "../axios";

export const getClientDetails = async () => {
    
  return await axios.get(`/api/client`)
}